import api from '@services/api';
import { RuleInput, RuleOverheadProject, SearchProjectInput } from '../models/ruleOverheadProject';

/**
 * <p>
 * API endpoints that cover all sharing related CRUD calls
 */

export const ruleOverHeadProjectApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createOrUpdateOverHeadProjectRule: builder.mutation<void, RuleInput>({
      query: (input) => ({
        url: '/indirect/rule-overhead-project/create',
        method: 'POST',
        body: input,
      }),
      invalidatesTags: ['RuleOverHeadProject'],
    }),
    searchOverHeadProjectRule: builder.query<RuleOverheadProject[], SearchProjectInput>({
      query: (input: SearchProjectInput) => ({
        url: encodeURI(`/indirect/rule-overhead-project/searchBy?searchTerm=${input.searchTerm}`),
      }),
      providesTags: ['RuleOverHeadProject'],
    }),
    removeOverHeadProjectRule: builder.mutation<void, number>({
      query: (id) => ({
        url: `/indirect/rule-overhead-project/delete?id=${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['RuleOverHeadProject'],
    }),
  }),
});

export const {
  useCreateOrUpdateOverHeadProjectRuleMutation,
  useRemoveOverHeadProjectRuleMutation,
  useSearchOverHeadProjectRuleQuery,
} = ruleOverHeadProjectApi;
